import {
    GetPicCodeByUrl
} from "@/utils/api.js";
const autograph = {
    state: {
        signUrl: "",
        PharDispensingNameUrl: null,
        PharReviewNameUrl: null,
        PharAuditNameUrl: null,
    },
    mutations: {
        //药师签名如果有资格就赋值
        upadateSignUrl(state, url) {
            state.signUrl = url
        },
        upadatePharDispensingNameUrl(state, url) {
            state.PharDispensingNameUrl = url ? url : "";
        },
        upadatePharReviewNameUrl(state, url) {
            state.PharReviewNameUrl = url
        },
        upadatePharAuditNameUrl(state, url) {
            state.PharAuditNameUrl = url
        },

    },
    actions: {
        //保存图片needMsg传过来的对象
        downloads(context, needMsg) {
            GetPicCodeByUrl(needMsg).then(res => {
                // let code = res.data.ImgUrl;
                // let parts = code.split(';base64,')
                // let contentType = parts[0].split(':')[1]
                // let raw = window.atob(parts[1])
                // let rawLength = raw.length
                // let uInt8Array = new Uint8Array(rawLength)
                // for (let i = 0; i < rawLength; ++i) {
                //     uInt8Array[i] = raw.charCodeAt(i)
                // }
                // let baseUrl = new Blob([uInt8Array], { type: contentType })
                // var alink = document.createElement("a");

                // alink.href = "data:image/png;base64," + baseUrl;
                // console.log(alink.href);
                // alink.download = needMsg.id || "pic"; //图片名
                // alink.click();

                if(res.code != 1){
                    context.commit('showMessage', {
                        message:res.msg,
                        type: 'error'
                      })
                    return
                }

                let image = new Image();
                let name = needMsg.id || "pic"; //图片名
                image.setAttribute('crossOrigin', 'anonymous')
                image.src = res.data.ImgUrl
                image.onload = () => {
                    let canvas = document.createElement('canvas')
                    canvas.width = image.width
                    canvas.height = image.height
                    let ctx = canvas.getContext('2d')
                    ctx.drawImage(image, 0, 0, image.width, image.height)
                    canvas.toBlob((blob) => {
                        let href = URL.createObjectURL(blob)
                        // download(url, name)
                        let eleLink = document.createElement('a')
                        eleLink.download = name
                        eleLink.href = href
                        eleLink.click()
                        eleLink.remove()
                        // 用完释放URL对象
                        URL.revokeObjectURL(href)
                    })
                }

                //                 function getBase64Image(img) {
                //                     var canvas = document.createElement("canvas");
                //                     $("canavs").hide();
                //                     canvas.width = img.width;
                //                     canvas.height = img.height;
                //                     var ctx = canvas.getContext("2d");
                //                     ctx.drawImage(img, 0, 0, img.width, img.height);
                //                     var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
                //                     var dataURL = canvas.toDataURL("image/" + ext);
                //                     return dataURL;
                //                 }
                //                 var imgLink = res.data.ImgUrl;
                //                 var tempImage = new Image();
                //                 tempImage.src = imgLink;
                //                 tempImage.crossOrigin = "*";
                //                 tempImage.onload = function () {
                //                     var base64 = getBase64Image(tempImage);
                //                     var alink = document.createElement("a");
                //                     alink.href = "data:image/png;base64," + base64;
                //                     console.log(alink.href);
                //                     alink.download = needMsg.id || "pic"; //图片名
                //                     alink.click();
                //                 }
            });
        }
    }
}

export default autograph